import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const API_KEY = "AIzaSyC1RP-8w-sZV7NrfiZ6_kNBugeJTycj-h4";
const BLOG_ID = "6772292124788323362";

const FullPost = () => {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageUrl, setImageUrl] = useState("https://via.placeholder.com/800x400");

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await fetch(`https://www.googleapis.com/blogger/v3/blogs/${BLOG_ID}/posts/${postId}?key=${API_KEY}`);
        const data = await res.json();

        // Extract first image URL
        const imgMatch = data.content.match(/<img[^>]*src=["']([^"']+)["'][^>]*>/i);

        let modifiedContent = data.content;

        if (imgMatch) {
            let imgUrl = imgMatch[1];
            imgUrl = imgUrl.replace(/\/s\d+(-c)?/, "/s1600"); // make high-res
            setImageUrl(imgUrl);
          
            // Remove the entire <img ...> tag from content
            modifiedContent = modifiedContent.replace(imgMatch[0], "");
          }
          

        // Set the post with modified content
        setPost({ ...data, content: modifiedContent });

      } catch (err) {
        console.error("Error fetching post:", err);
        setError("Failed to load post.");
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [postId]);

  if (loading) return <p>Loading full post...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;
  if (!post) return <p>Post not found.</p>;

  return (
    <div style={{ padding: '40px 20px', maxWidth: 'auto', margin: '0 auto',backgroundColor: "white" }}>
      <Link to="/blog" style={{ textDecoration: 'none', color: 'blue' }}>← Back to Blog</Link>
      <h1 style={{ marginTop: '20px', fontSize: '3.2rem' }}>{post.title}</h1>
      <p style={{ color: '#777', marginBottom: '20px' }}>
        Published on: {new Date(post.published).toLocaleString()}
      </p>

      {/* Featured Image */}
      <img 
        src={imageUrl}
        alt={post.title}
        style={{
          width: '100%',
          height: 'auto',
          maxHeight: '500px',
          objectFit: 'cover',
          borderRadius: '10px',
          marginBottom: '30px'
        }}
      />

      {/* Post Content */}
      <div
        dangerouslySetInnerHTML={{ __html: post.content }}
        style={{ lineHeight: '0.5', fontSize: '1.1rem' }}
      />
    </div>
  );
};

export default FullPost;
